var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfoCircle01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 8a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0zM8.813 4.75a.813.813 0 11-1.625 0 .813.813 0 011.625 0zM7.188 7.188a.813.813 0 000 1.625v2.437c0 .449.363.813.812.813h.813a.813.813 0 000-1.626V8A.813.813 0 008 7.187h-.812z",
    fill: "#98A2B3"
  })));
}

export default SvgInfoCircle01;